const state = {
  list: [],
}

const getters = {
}

const mutations = {
  setList (state, v) {
    state.list = v
  }
}

const actions = {
  apply ({ state, commit, rootState }, params) {
    return rootState.axios.post('/knapsack/v1frontend/knapsack-user-goods/apply', params)
  },
  presented ({ state, commit, rootState }, params) {
    return rootState.axios.post('/knapsack/v1frontend/knapsack-user-goods/presented', params)
  },
  search ({ state, commit, rootState }, params) {
    return rootState.axios.get('/knapsack/v1frontend/knapsack-user-goods/search', {
      params: {
        pageSize: 200,
        page: 1,
        ...params,
      }
    }).then(res => {
      commit('setList', res.data.list)
    })
  },
  rewardNewbieBusyfee ({ state, commit, rootState }, params) {
    return rootState.axios.get('/knapsack/v1frontend/knapsack-user-goods/reward-newbie-busyfee', { params })
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
